import React, { forwardRef } from 'react';
import { Box, Container, Typography } from '@mui/material';

const AppHeroView = forwardRef(function HeroSection(
    {
        title,
        description,
        sx = { bgcolor: 'primary.main', color: 'primary.contrastText', py: 8 },
        titleProps = {variant: "h2", gutterBottom: true},
        descriptionProps = {variant: "h6", gutterBottom: true},
        renderBottomContent = null,
    },
    ref
) {
    return (
        <Box ref={ref} sx={sx}>
            <Container maxWidth="lg">
                <Typography {...titleProps}>
                    {title}
                </Typography>
                <Typography {...descriptionProps}>
                    {description}
                </Typography>
                {renderBottomContent?.()}
            </Container>
        </Box>
    );
});

export { AppHeroView };